import { isDefined } from "@clipboard-health/util-ts";
import { type CoreMessageType } from "@sendbird/uikit-react/types/utils";
import { HIDDEN_MESSAGE_TYPES } from "@src/appV2/Chat/constants";
import { CustomMessageTypes } from "@src/appV2/Chat/type";
import { type Shift } from "@src/lib/interface/src";

export function getUpcomingShiftFromInputEtaMessage(
  message: CoreMessageType,
  upcomingShifts: Shift[]
): Shift | undefined {
  if (!isDefined(message.data)) {
    return undefined;
  }

  // message.data contains single quote, make sure we remove it before JSON.parse
  const messageData = JSON.parse(message.data.replace(/'/g, '"')) as {
    shiftId: string;
  };
  return upcomingShifts.find((shift: Shift) => shift._id === messageData.shiftId);
}

export function hideMessage(message: CoreMessageType, upcomingShifts: Shift[]): boolean {
  const { customType } = message;

  if (HIDDEN_MESSAGE_TYPES.includes(customType)) {
    return true;
  }

  if (customType === CustomMessageTypes.INPUT_ETA) {
    const shift = getUpcomingShiftFromInputEtaMessage(message, upcomingShifts);
    return !isDefined(shift);
  }

  return false;
}
